import React, { useState, useEffect, useRef } from 'react';
import propTypes from 'prop-types';
import styled from '@emotion/styled';
import { useMediaQuery } from '@mui/material';
import { theme } from '../../themes/default-theme';
import ModelLogo from '../../components/multimedia/ModelLogo';
import ModelImageText from '../../components/multimedia/ModelImageText';
import ModelStepsLinks from '../../components/ui/ModelStepsLinks';
import { modelStepsData } from '../../components/methods/modelStepsData';
import Text from '../../components/typography';
import { Cta } from '../../components/ui';
import Link from 'next/link';
import ModelFooter from '../../components/content/ModelFooter';
import NavArrowRight from '../../assets/icons/new_nav_arrow_right.svg';
import { setSavedData, getSavedData } from "../../components/methods/setLocalStorage";
import { buildPriceData } from '../../components/methods/buildPriceDataName';
import { BuildPriceRouteName } from '../../components/methods/buildPriceRouteName';
import { useInView } from 'react-intersection-observer';
import { useRouter } from 'next/router';
import ModelPrice from '../../components/content/ModelPrice'

const Wrapper = styled.div`
    padding-left: 20px;
    padding-right: 20px;
    ${theme.breakpoints.up('lg')} {
        padding-left: 40px;
        padding-right: 40px;
    }
    ${theme.breakpoints.down('sm')} { 
        margin-top: 15px;
        // margin-bottom: 103px;
    }
    h1 {
        margin-bottom: 20px;
        color: #010101;
        ${theme.breakpoints.up('md')} {
            font-size: 34px;
            padding-top: 37px;
        }   
        ${theme.breakpoints.down('sm')} {
            font-size: 18px;
            padding-top: 25px;
        } 
    }
`
const Container = styled.div`
    max-width: 1400px;
    margin: auto;

`

const Inner = styled.div`
    ${theme.breakpoints.up('md')} {
        display: flex;
        gap: 60px;
        justify-content: space-between;
        padding-bottom: 100px;
    }
`

const FirstSection = styled.div`
    ${theme.breakpoints.down('1600')} {
        > a {
            margin-left: 63px;
            margin-bottom: 10px;
        }
    }
    ${theme.breakpoints.up('md')} {
        > div {
            margin-left: 63px;
        }
        padding-top: 37px;
    }
    ${theme.breakpoints.down('sm')} { 
        text-align: center;
    }
    > a {
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 21px;
        text-transform: uppercase;
        text-decoration: none;
        display: flex;
        align-items: center;
        &:before {
            content: url(${NavArrowRight});
            margin-right: 10px;
            transform: scale(-1);
            filter: brightness(0) saturate(100%) invert(26%) sepia(36%) saturate(4535%) hue-rotate(194deg) brightness(103%) contrast(99%);
        }
    }

`
const SecondSection = styled.div`
    width: 100%;
    ${theme.breakpoints.up('md')} {
        padding-left: 60px;
        border-left: 1px solid #D9D9D9;
        max-width: 505px;
    }
    ${theme.breakpoints.down('sm')} {
        > a {
            font-size: 11px;
            font-style: normal;
            font-weight: 700;
            line-height: 21px;
            text-transform: uppercase;
            text-decoration: none;
            display: flex;
            align-items: center;
            margin-top: 20px;
            &:before {
                content: url(${NavArrowRight});
                line-height: 0;
                width: 4px;
                height: auto;
                margin-right: 7px;
                transform: scale(-1);
                filter: brightness(0) saturate(100%) invert(26%) sepia(36%) saturate(4535%) hue-rotate(194deg) brightness(103%) contrast(99%);
            }
        }
    }
`
const ModelHead = styled.div`
    margin: 20px 0;
    color: ${theme.palette.charcoal};
    ${theme.breakpoints.up('md')} {
        h4 {
            font-size: 22px;
            line-height: 22px;
        }
    }
    ${theme.breakpoints.up('lg')} {
        margin: 40px 0 20px;
    }
    ${theme.breakpoints.down('sm')} {
        margin-bottom: 20px;
        h4 {
            font-size: 16px;
            line-height: 22px;
        }
    }
`
const ButtonContainer = styled.div`
    ${theme.breakpoints.up('md')} {
        margin-top: 40px;
    }
    ${theme.breakpoints.down('sm')} {
        padding-top: 8px;
        border-top: 1px solid ${theme.palette.middleGrey};
        position: absolute;
        opacity: 0;
        visibility: hidden;
    }
    ${props => props.fixed && `
        ${theme.breakpoints.down('sm')} {
            position: fixed;
            bottom: 0;
            width: 100%;
            left: 0;
            padding: 11px 20px;
            z-index: 115;
            background: #F3F4F7;
            opacity: 1;
            visibility: visible;
        }
    `}
   a {
        text-transform: uppercase;
   }
`
const ModelFooterContainer = styled.div`
    ${theme.breakpoints.down('1600')} {
       margin-left: 63px;
    }
    ${theme.breakpoints.down('sm')} {
        margin-left: 0;
     }
     ${theme.breakpoints.up('lg')} {
        margin-bottom: 35px;
     }
     ${theme.breakpoints.down('md')} {
        margin-top: 20px;
        margin-bottom: 20px;
     }
`
const ModelPriceContainer = styled.div`
    position: fixed;
    width: 100%;
    right: 0;
    z-index: 3;
    ${theme.breakpoints.up('lg')} {
        > div {
            width: 100%;
        }
    }
    ${theme.breakpoints.up('lg')} {
        bottom: -4px;
        > div {
            float: right;
        }
    }
    ${theme.breakpoints.down('md')} {
        bottom: -4px;
        > div {
            width: 100%;
            margin-top: 15px;
        }
    }
    ${props => props.fixed == 1 ? `
        position: fixed;
        ${theme.breakpoints.down('md')} {
            bottom: 0;
        }
    `: `
        position: absolute;
        ${theme.breakpoints.down('md')} {
            bottom: -4px;
        }
    `}
    ${theme.breakpoints.up('lg')} {
        ${props => props.containerWidth > 0 ? `
            > div {
                min-width: ${400 + props.containerWidth}px;
                max-width: ${400 + props.containerWidth}px;
            }
        `:`
            > div {
                min-width: ${400 + 0}px;
                max-width: ${400 + 0}px;
            }
        `}
    }
    ${theme.breakpoints.up('1280')} {
        ${props => props.containerWidth > 0 ? `
            > div {
                min-width: ${445 + props.containerWidth}px;
                max-width: ${445 + props.containerWidth}px;
            }
        `:`
            > div {
                min-width: ${445 + 0}px;
                max-width: ${445 + 0}px;
            }
        `}
    }
`


const InviewContainer = styled.div`
    height: 200px;
    width: 50px;
    position: absolute;
`

const modelBeginPageDefaultPropSeriesUrl = {};
const modelBeginPageDefaultPropModelImageText = {};
const modelBeginPageDefaultPropModelLogo = {};
const modelBeginPageDefaultPropModelFooter = {};
const modelBeginPageDefaultPropLocation = {};
const modelBeginPageDefaultPropDealers = [];
const modelBeginPageDefaultPropCountryProps = {};

const ModelBeginPage = (props) => {
    props = {
        ...props,
        seriesName: typeof props.seriesName === "undefined" ? null : props.seriesName,
        seriesUrl: typeof props.seriesUrl === "undefined" ? modelBeginPageDefaultPropSeriesUrl : props.seriesUrl,
        seriesParams: typeof props.seriesParams === "undefined" ? null : props.seriesParams,
        modelsCount: typeof props.modelsCount === "undefined" ? null : props.modelsCount,
        modelName: typeof props.modelName === "undefined" ? null : props.modelName,
        modelUrl: typeof props.modelUrl === "undefined" ? null : props.modelUrl,
        modelImageText: typeof props.modelImageText === "undefined" ? modelBeginPageDefaultPropModelImageText : props.modelImageText,
        modelLogo: typeof props.modelLogo === "undefined" ? modelBeginPageDefaultPropModelLogo : props.modelLogo,
        modelFooter: typeof props.modelFooter === "undefined" ? modelBeginPageDefaultPropModelFooter : props.modelFooter,
        location: typeof props.location === "undefined" ? modelBeginPageDefaultPropLocation : props.location,
        dealers: typeof props.dealers === "undefined" ? modelBeginPageDefaultPropDealers : props.dealers,
        countryProps: typeof props.countryProps === "undefined" ? modelBeginPageDefaultPropCountryProps : props.countryProps
    };

    const {
        seriesName,
        seriesUrl,
        seriesParams,
        modelsCount,
        modelName,
        modelUrl,
        modelImageText,
        modelLogo,
        modelFooter,
        location,
        dealers,
        countryProps,
        disablePrice
    } = props

    const router = useRouter();
    let res = JSON.parse(getSavedData(buildPriceData)) || {};
    const [showBuildAndPrice, setShowBuildAndPrice] = useState(true);
    const [getLocation, setGetLocation] = useState(null);
    const [openPostcodePopup, setOpenPostcodePopup] = useState(false);
    const [fixed, setFixed] = useState(true);
    // Media Breakpoint Start
    const media = useMediaQuery(theme.breakpoints.up('0'));
    const desktopView = useMediaQuery(theme.breakpoints.up('md'));
    const mobileView = useMediaQuery(theme.breakpoints.down('sm'));
    // Media Breakpoint End

    const handleSaveData = (seriesName) => {
     
     if (res && res.seriesName && seriesName && res.seriesName == seriesName) {
         res.seriesName = seriesName
         setSavedData(
             buildPriceData,
             JSON.stringify(
                 res
             ),
             86400 // 1 day
         );

     } else {
         res = {};
         res.seriesName = seriesName;
         setSavedData(
             buildPriceData,
             JSON.stringify(
                 res
             ),
             86400 // 1 day
         );
     }
     setSavedData(
         BuildPriceRouteName,
         router?.pathname && router.pathname,
         7200 // 2 hours
     );  
 }

    const openPostcode = (e) => {
        e.preventDefault();
        setOpenPostcodePopup(!openPostcodePopup);
    }
    const getCurrentSetLocation = (currentLocation) => {
        setGetLocation(currentLocation)
    }

    // useEffect(() => {
    //     if((document.location.hostname == 'www.jaycoadelaide.com.au') || (document.location.hostname == 'www.jaycoalbertpark.com.au') || (document.location.hostname.indexOf('jayco-com-au.au1.staticlyproject.com') > -1) || (document.location.hostname.indexOf('localhost') > -1)) {
    //       setShowBuildAndPrice(true);
    //     } else {
    //       setShowBuildAndPrice(false);
    //       router.push('/404');
    //     }
    // }, [])


    const { ref: inViewRef, inView, entry } = useInView({
        /* Optional options */
        threshold: 0,
      });


    useEffect(() => {
        const handleScroll = (e) => {
             if ((!inView)) {
                setTimeout(() => {

                setFixed(true)
                }, 300)
            } else {
                setTimeout(() => {
                 setFixed(false)
                }, 300)
            }
        }
        handleScroll();
        window.addEventListener("resize", handleScroll);
        return () => {
             window.removeEventListener("resize", handleScroll);
        }

    }, [inView && inView, media]);

    // Set Dynamic width
    const ref = useRef(null);
    const ref2 = useRef(null);
    const [width, setWidth] = useState(0);
    const[containerWidth, setConntainerWidth] = useState(0);
    useEffect(() => {
        if (ref.current && ref.current.clientWidth) {
            setWidth(ref.current.clientWidth);
        }
        function handleWindowResize() {
            if (ref.current && ref.current.clientWidth) {
                setWidth(ref.current.clientWidth);
            }
        }
        window.addEventListener('resize', handleWindowResize);

        if (ref2.current && ref2.current.clientWidth) {
            setConntainerWidth(ref2.current.clientWidth);
        }
        function handleWindowResize2() {
            if (ref2.current && ref2.current.clientWidth) {
                setConntainerWidth(ref2.current.clientWidth);
            }
        }
        window.addEventListener('resize', handleWindowResize2);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
            window.removeEventListener('resize', handleWindowResize2);
        };

    }, [media]);

    const disabledSteps =  (res && res.selectedModel && Object.values(res.selectedModel).length > 0 && (getLocation && process.env.DEALER_SITE === true)) ? [''] : (!getLocation && process.env.DEALER_SITE !== true) ? ['1', '2', '3', '4', '5'] : (!res.selectedModel) && ['2', '3', '4', '5'];

    // console.log('Begin Page', res && res)

    const currentWidth = (width - containerWidth) / 2

    const currentPrice = 10000;
    const additionalPrice = 200;
    const rates = {};
    // const disablePrice = true;

    return (showBuildAndPrice && <>
        <ModelLogo 
            {...modelLogo}
        />
        <Wrapper ref={ref}>
            <Container ref={ref2}>
                <Inner>
                    <FirstSection>
                        {desktopView &&
                            <Link href="/build-price">
                                
                                    Back
                                
                            </Link>
                        }
                        <ModelImageText {...modelImageText} />
                    </FirstSection>
                    <SecondSection>
                        {seriesName && desktopView &&
                                <Text variant="h1" weight={800} uppercase>{seriesName.indexOf('Jayco') > -1 ? seriesName : `Jayco ${seriesName}`}</Text>
                        }
                        <ModelHead>
                                <Text variant="h4" weight={700}>Build your {seriesName.indexOf('Jayco') > -1 ? seriesName : `Jayco ${seriesName}`}</Text>
                        </ModelHead>
                        <ModelStepsLinks
                                modelStepsData={modelStepsData(seriesUrl && seriesUrl.link && seriesUrl.link.href, res?.selectedModelFloorplan?.activeFloorPlanModel?.uri && res.selectedModelFloorplan.activeFloorPlanModel.uri, disabledSteps, 3)}
                        />
                        {mobileView &&
                            <Link href="/build-price">
                                
                                    Back
                                
                            </Link>
                        }
                        {(getLocation || process.env.DEALER_SITE === true) ?
                            <ButtonContainer fixed={fixed ? 1 : 0}>
                                <Link href={seriesUrl && seriesUrl.link && seriesUrl.link.href && (getLocation || process.env.DEALER_SITE === true) ? modelsCount && modelsCount > 1 ?`${seriesUrl.link.href}?variant=true` : `${seriesUrl.link.href}?floorplan=true` : '#'} onClick={handleSaveData(seriesName)}>

                                    <Cta>Get Started</Cta>

                                </Link>
                            </ButtonContainer>
                        :
                        <>
                            <ButtonContainer fixed={fixed ? 1 : 0}>
                                <Link href={'#'} onClick={(e) => openPostcode(e)}>

                                    <Cta>Get Started</Cta>

                                </Link>
                            </ButtonContainer>
                        
                        </>
                        }
                    </SecondSection>

                </Inner>
            </Container>
            {/* this needs to be fixed because commenting it out */}
            {/* {!disablePrice &&
                <>
                    <ModelPriceContainer containerWidth={currentWidth > 0 ? currentWidth : 0} fixed={fixed ? 1 : 0}>
                        <ModelPrice
                            price={currentPrice}
                            additionalPrice={additionalPrice}
                            rates={rates}
                            // buildUrl={}
                            // country={}
                        />
                    </ModelPriceContainer>
                </>
            } */}
            <ModelFooterContainer>
                <ModelFooter 
                    {...modelFooter}
                    location={location}
                    dealers={dealers}
                    countryProps={countryProps}
                    getCurrentSetSetLocation={getCurrentSetLocation}
                    openPostcodePopup={openPostcodePopup}
                    setOpenPostcodePopup={setOpenPostcodePopup}
                />
            </ModelFooterContainer>


            <InviewContainer ref={inViewRef}>

            </InviewContainer>
            
        </Wrapper>
    </>);
}

ModelBeginPage.propTypes = {
    seriesName: propTypes.string,
    seriesUrl: propTypes.object,
    seriesParams: propTypes.string,
    modelsCount: propTypes.number,
    modelName: propTypes.string,
    modelUrl: propTypes.string,
    modelImageText: propTypes.object,
    modelLogo: propTypes.object,
    modelFooter: propTypes.object,
    location: propTypes.object,
    dealers: propTypes.array,
    countryProps: propTypes.object,
    disablePrice: propTypes.bool
}

export default ModelBeginPage